// packages/utils/clipboard.ts
import { Platform } from 'react-native';

let Clipboard: typeof import('expo-clipboard') | null = null;

if (Platform.OS !== 'web') {
  try {
    Clipboard = require('expo-clipboard');
  } catch (e) {
    console.error('expo-clipboard not available:', e);
  }
}

export const copyToClipboard = async (text: string) => {
  if (!text) return;

  if (Platform.OS === 'web') {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error('Failed to copy text on web:', err);
    }
  } else if (Clipboard) {
    try {
      await Clipboard.setStringAsync(text);
    } catch (err) {
      console.error('Failed to copy text on native:', err);
    }
  } else {
    console.warn('Clipboard API not available.');
  }
};
